import type * as React from 'react';
import { post } from '@Domain/Api';
import documentTypeArchived, {
	type DocumentTypeArchivedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeArchived';
import documentTypeArchivingFailed, {
	type DocumentTypeArchivingFailedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeArchivingFailed';
import type ArchiveDocumentType from '@Application/Documents/DocumentTypes/Commands/ArchiveDocumentType';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTypeArchivedAction | DocumentTypeArchivingFailedAction;

export default (command: ArchiveDocumentType) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// `204`, no body: `post<void>` with an empty object body — the endpoint takes none.
			await post<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/document-types/${command.documentTypeId}/archivals`,
				{},
			);

			const action = documentTypeArchived(
				{ documentTypeId: command.documentTypeId, archivedAt: new Date().toISOString() },
				command.accountId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTypeArchivingFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
